import type { ITaxonomyGroup } from '$shared/interfaces/api/ITaxonomyGroup';
import BaseModel from './BaseModel';

export class TaxonomyGroup extends BaseModel<ITaxonomyGroup> {
  public get id(): string {
    return this.response?.id || '';
  }

  public get name(): string {
    return this.response?.name || '';
  }
}
